declare namespace $ {

	type $mol_button_minor__click_shm_hitalama_guide_item_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_item['toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__event_shm_hitalama_guide_item_2 = $mol_type_enforce<
		({ 
			dblclick( next?: ReturnType< $shm_hitalama_guide_item['rename_start'] > ): ReturnType< $shm_hitalama_guide_item['rename_start'] >,
		})  & ReturnType< $mol_button_minor['event'] >
		,
		ReturnType< $mol_button_minor['event'] >
	>
	type $mol_button_minor__sub_shm_hitalama_guide_item_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_check__aria_role_shm_hitalama_guide_item_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['aria_role'] >
	>
	type $mol_check__checked_shm_hitalama_guide_item_5 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__click_shm_hitalama_guide_item_6 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_check['click'] >
	>
	type $mol_check__sub_shm_hitalama_guide_item_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check['sub'] >
	>
	type $mol_pick__align_shm_hitalama_guide_item_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__Anchor_shm_hitalama_guide_item_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_item['Anchor'] >
		,
		ReturnType< $mol_pick['Anchor'] >
	>
	type $mol_pick__event_shm_hitalama_guide_item_10 = $mol_type_enforce<
		({ 
			contextmenu( next?: ReturnType< $shm_hitalama_guide_item['contextmenu'] > ): ReturnType< $shm_hitalama_guide_item['contextmenu'] >,
		})  & ReturnType< $mol_pick['event'] >
		,
		ReturnType< $mol_pick['event'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_guide_item_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_item['menu_content'] >
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $shm_confirm_delete__title_shm_hitalama_guide_item_12 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_confirm_delete['title'] >
	>
	type $shm_confirm_delete__confirmed_shm_hitalama_guide_item_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_item['remove'] >
		,
		ReturnType< $shm_confirm_delete['confirmed'] >
	>
	type $mol_link__current_shm_hitalama_guide_item_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_item['current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__arg_shm_hitalama_guide_item_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_item['page_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_hitalama_guide_item_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_item['title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_string__value_shm_hitalama_guide_item_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_item['draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_hitalama_guide_item_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_item['rename_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_hitalama_guide_item_19 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_hitalama_guide_item['rename_submit'] > ): ReturnType< $shm_hitalama_guide_item['rename_submit'] >,
			keydown( next?: ReturnType< $shm_hitalama_guide_item['rename_keydown'] > ): ReturnType< $shm_hitalama_guide_item['rename_keydown'] >,
			pointerdown( next?: ReturnType< $shm_hitalama_guide_item['input_pointerdown'] > ): ReturnType< $shm_hitalama_guide_item['input_pointerdown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	export class $shm_hitalama_guide_item extends $mol_view {
		content( ): readonly($mol_view)[]
		rename_start( next?: any ): any
		Folder_icon( ): $mol_icon_folder
		title( ): string
		Group( ): $mol_button_minor
		Anchor( ): $mol_check
		contextmenu( next?: any ): any
		menu_content( ): readonly($mol_view)[]
		remove( next?: any ): any
		page_arg( ): Record<string, any>
		draft( next?: string ): string
		rename_submit( next?: any ): any
		rename_keydown( next?: any ): any
		input_pointerdown( next?: any ): any
		catalog( ): $shm_hitalama_guide_catalog
		id( ): string
		current( ): boolean
		toggle( next?: any ): any
		sub( ): ReturnType< $shm_hitalama_guide_item['content'] >
		Menu( ): $mol_pick
		Delete( ): $shm_confirm_delete
		Link( ): $mol_link
		Input( ): $mol_string
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map